// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.3.0",
  date: "2026-07-14T13:08:15.343Z",
  gitInfo: {
    dirty: false,
    raw: "21a151dfb",
    hash: "21a151dfb",
    distance: null,
    tag: null,
    semver: null,
    suffix: "21a151dfb",
    semverString: null
  }
};
/* tslint:enable */
